import React from "react";

import Annotations from "./Annotations";
import StoreProductAnnotationOverlay from "./StoreProductAnnotationOverlay";

class StoreProductAnnotations extends Annotations {
  /**
   * Singleton initializer, call as many times as you need.
   *
   * @return {StoreProductAnnotations} An instance of this class.
   */
  static init(page, pagesPerSheet) {
    if (!this.instance) {
      this.instance = new StoreProductAnnotations(page, pagesPerSheet);
    }
    return this.instance;
  }

  /**
   * Called on turbolinks page navigation to make sure the singleton instance
   * gets cleaned up.
   */
  static unload() {
    this.instance = null;
  }

  constructor(currPage) {
    super(currPage);
    this.name = "StoreProductAnnotations";
  }

  popupComponent(annotation, number, id) {
    return (
      <StoreProductAnnotationOverlay
        klass={this}
        id={id}
        annotation={annotation}
        number={number}
        annotationTypes={this.annotationTypes}
        roleType={this.roleType}
        readOnly={this.readOnly}
        pagesPerSheet={this.pagesPerSheet}
      />
    );
  }
}

export default StoreProductAnnotations;
